import { useEffect, useState } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MovieCard from "../components/MovieCard";

export default function CatalogPage({ kind = "movies" }) {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/${kind === "new" ? "movies" : kind}`).then((r) => {
      // sort by year desc for "new"
      const data = kind === "new" ? [...r.data].sort((a, b) => (b.releaseYear || 0) - (a.releaseYear || 0)) : r.data;
      setItems(data);
      setLoading(false);
    });
  }, [kind]);

  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))];
  const filtered = filter === "All" ? items : items.filter((i) => i.category === filter);

  const titles = {
    movies: { h1: "Movies", desc: "Cinema-quality films, all in one place." },
    series: { h1: "TV Shows", desc: "Binge-worthy series and originals." },
    new: { h1: "New & Popular", desc: "Fresh drops, trending now." },
  };
  const meta = titles[kind] || titles.movies;

  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid={`catalog-${kind}`}>
      <Navbar />
      <div className="pt-32 px-4 sm:px-12 max-w-[1600px] mx-auto pb-20">
        <h1 className="text-5xl sm:text-6xl font-black tracking-tighter mb-2" style={{ fontFamily: "Outfit" }}>{meta.h1}</h1>
        <p className="text-[#999] mb-8">{meta.desc}</p>
        <div className="flex gap-2 overflow-x-auto no-scrollbar mb-8 pb-2">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition ${filter === c ? "bg-[#E50914] text-white" : "bg-white/5 hover:bg-white/10 text-[#ccc]"}`}
              data-testid={`filter-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>
        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
            {Array.from({ length: 12 }).map((_, i) => (
              <div key={i} className="skeleton aspect-[2/3] rounded-lg" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
            {filtered.map((item) => (
              <MovieCard key={item.id} item={item} type={kind === "series" ? "series" : "movie"} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
